import _sfc_main from "./MonthView.vue2.js";
/* empty css               */
import _export_sfc from "../../../_virtual/_plugin-vue_export-helper.js";
const MonthView = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-e6e5ad80"]]);
export {
  MonthView as default
};
//# sourceMappingURL=MonthView.vue.js.map
